export default {
    loaded: ({lootbox}) => lootbox.loaded,
    boxes: ({lootbox}) => lootbox.boxes,
    box: ({lootbox}) => lootbox.box,
    buttons: {
        open: ({lootbox}) => lootbox.buttons.open,
        prize_redeem: ({lootbox}) => lootbox.buttons.prize_redeem,
        prize_sell: ({lootbox}) => lootbox.buttons.prize_sell
    }
}